import {
    useEffect,
    useState,
} from 'react';

const MS_PER_DAY = 24 * 60 * 60 * 1000;
// Timers can fire a hair early; land safely on the new day instead of re-reading the old one.
const MIDNIGHT_GRACE_MS = 1000;

export const toUtcDay = (unixSeconds: number) => new Date(unixSeconds * 1000).toISOString()
    .slice(0, 10);

// Today's UTC calendar day, re-evaluated at every UTC midnight so a long-lived tab keeps up.
export const useUtcToday = (): string => {
    const [ today, setToday ] = useState(() => toUtcDay(Math.floor(Date.now() / 1000)));

    // The timer reschedules itself rather than keying the effect on `today`: if a tick ever
    // produced the same day string, a state-keyed effect would never run again.
    useEffect(() => {
        let timer: ReturnType<typeof setTimeout>;
        const schedule = () => {
            const msUntilMidnight = MS_PER_DAY - (Date.now() % MS_PER_DAY) + MIDNIGHT_GRACE_MS;
            timer = setTimeout(() => {
                setToday(toUtcDay(Math.floor(Date.now() / 1000)));
                schedule();
            }, msUntilMidnight);
        };
        schedule();
        return () => clearTimeout(timer);
    }, []);

    return today;
};
